
import MomSysSelectStandardMaterial from "../screens/MomSysSelectStandardMaterial";
import MomSysSelectNonStandardMaterial from "../screens/MomSysSelectNonStandardMaterial";

function MomSysSelectStandardShipDetail(props) {

  const { standard , onSelect, onInitialized,  onLoadData } = props;
  
  return (
    <>
    {
      standard
      ?
      <MomSysSelectStandardMaterial
        materialCode = {onSelect.materialCode}
        materialCodeVer = {onSelect.materialCodeVer}
        orderBuyerId = {onSelect.orderBuyerId}
        shipQty = {onSelect.shipQty}
        onInitialized = {onInitialized}
        onLoadData = {onLoadData}
      />
      :
      <MomSysSelectNonStandardMaterial
        materialName = {onSelect.materialName}
        orderBuyerId = {onSelect.orderBuyerId}
        shipQty = {onSelect.shipQty}
        onInitialized ={onInitialized}
        onLoadData = {onLoadData}
      />
    }
    </>

  );
}

export default MomSysSelectStandardShipDetail;
